module.exports = __webpack_public_path__ + "img/tarj-1.82167762.svg";